import { render, staticRenderFns } from "./CourseItemDetail.vue?vue&type=template&id=1af19241"
import script from "./CourseItemDetail.vue?vue&type=script&lang=js"
export * from "./CourseItemDetail.vue?vue&type=script&lang=js"
import style0 from "./CourseItemDetail.vue?vue&type=style&index=0&id=1af19241&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports